import ManageTokenGrid from "./ManageTokenGrid";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";
import ManageTokenGridBanner from "./ManageTokenGridBanner";
import Loader from "components/common/controls/Loader";
import { getTokensBySubscriptionId } from "store/slices/TokenSlice";
import { getSelectedProductSubscriptionId } from "shared/utility/ProductSubscriptionHelper";
import { useEffect } from "react";

interface Props {
  tokens: SubscriptionTokenResponse[];
  isLoading?: boolean;
  tokensLoaded: boolean;
  currentProductSubscriptionId?: number | null;
  loadTokens: (subscriptionId: number) => void;
}

export function ManageToken(props: Props) {
  const {
    tokens,
    tokensLoaded,
    isLoading,
    currentProductSubscriptionId,
    loadTokens,
  } = props;

  useEffect(() => {
    if (!tokensLoaded && currentProductSubscriptionId) {
      loadTokens(currentProductSubscriptionId);
    }
  }, [tokensLoaded, currentProductSubscriptionId, loadTokens]);

  return (
    <div>
      <div className="mb-6">
        <ManageTokenGridBanner />
      </div>
      {tokensLoaded && <ManageTokenGrid dataSource={tokens} />}
      <Loader isVisible={isLoading} />
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  const checkIfIsLoading = () => {
    return state.tokenData.loading;
  };

  return {
    ...props,
    tokensLoaded: state.tokenData.tokensLoaded,
    tokens: state.tokenData.tokens,
    isLoading: checkIfIsLoading(),
    currentProductSubscriptionId: getSelectedProductSubscriptionId(state),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    loadTokens: (subscriptionId: number) =>
      dispatch(getTokensBySubscriptionId(subscriptionId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageToken);
